<template>
  <div class="monthCollectOutside">
    <el-card class="monthCollectOutside_card">
      <div class="box">
        <div class="cardTitle c-5470c6">物业月度实收报表统计</div>
        <el-form :inline="true" class="flexForm">
          <!-- 选择日期 -->
          <el-form-item label="起止日期">
            <el-date-picker type="month" :placeholder="$t('lang.lab_startDate')" value-format="timestamp"
              v-model="startTimeWy"></el-date-picker>
            <span style="padding: 0 1px"> 至 </span>
            <el-date-picker type="month" :placeholder="$t('lang.lab_endDate')" value-format="timestamp"
              v-model="endTimeWy">
            </el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="submitWy()">{{$t('lang.btn_search')}}</el-button>
        </el-form>
      </div>

      <div class="container">
        <div id="echart1"></div>
      </div>
    </el-card>
    <el-card class="monthCollectOutside_card">
      <div class="box">
        <div class="cardTitle c-55ccb9">车位月度实收报表统计</div>
        <el-form :inline="true" class="flexForm">
          <!-- 选择日期 -->
          <el-form-item label="起止日期">
            <el-date-picker type="month" :placeholder="$t('lang.lab_startDate')" value-format="timestamp"
              v-model="startTimeCw"></el-date-picker>
            <span style="padding: 0 1px"> 至 </span>
            <el-date-picker type="month" :placeholder="$t('lang.lab_endDate')" value-format="timestamp"
              v-model="endTimeCw">
            </el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="submitCw()">{{$t('lang.btn_search')}}</el-button>
        </el-form>
      </div>
      <div class="container">
        <div id="echart2"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:
   *@Description:
   *@author:xubz
   *@Copyright:格众科技
   *@date:
   */
  export default {
    data() {
      return {
        gardenId: this.$store.getters.gardenId,
        nowTime: new Date().getTime(),
        startTimeWy: this.getTimestampOneYearAgo(),
        endTimeWy: new Date().getTime(),
        startTimeCw: this.getTimestampOneYearAgo(),
        endTimeCw: new Date().getTime(),
        monthCollectOutsideDataWy: '',
        monthCollectOutsideDataCw: '',
      }
    },
    created() {
      this.monthCollectOutsideWy()
      this.monthCollectOutsideCw()
    },
    watch: {

    },
    methods: {
      // 返回
      jump() {
        this.$router.go(-1)
      },
      // 获取11个月前的时间戳
      getTimestampOneYearAgo() {
        const now = new Date()
        now.setMonth(now.getMonth() - 11)
        return now.getTime()
      },
      // 物业查询
      submitWy() {
        if (this.startTimeWy == null) {
          this.startTimeWy = this.getTimestampOneYearAgo()
        }
        if (this.endTimeWy == null) {
          this.endTimeWy = new Date().getTime() - 1000
        }
        this.nowTime = new Date().getTime()
        if (this.startTimeWy == '' && this.endTimeWy == '') {
          this.monthCollectOutsideWy()
        } else if (this.startTimeWy == '' && this.endTimeWy != '') {
          this.$message.error('请选择开始日期')
        } else if (this.startTimeWy != '' && this.endTimeWy == '') {
          this.$message.error('请选择结束日期')
        } else if (this.startTimeWy >= this.endTimeWy) {
          this.$message.error('开始日期不能大于或等于结束日期')
        } else if (this.startTimeWy > this.nowTime) {
          this.$message.error('开始日期不能大于当前日期')
        } else if (this.endTimeWy > this.nowTime) {
          this.$message.error('结束日期不能大于当前日期')
        } else {
          this.monthCollectOutsideWy()
        }
      },
      // 车位查询
      submitCw() {
        if (this.startTimeCw == null) {
          this.startTimeCw = this.getTimestampOneYearAgo()
        }
        if (this.endTimeCw == null) {
          this.endTimeCw = new Date().getTime()
        }
        this.nowTime = new Date().getTime()
        if (this.startTimeCw == '' && this.endTimeCw == '') {
          this.monthCollectOutsideCw()
        } else if (this.startTimeCw == '' && this.endTimeCw != '') {
          this.$message.error('请选择开始日期')
        } else if (this.startTimeCw != '' && this.endTimeCw == '') {
          this.$message.error('请选择结束日期')
        } else if (this.startTimeCw >= this.endTimeCw) {
          this.$message.error('开始日期不能大于或等于结束日期')
        } else if (this.startTimeCw > this.nowTime) {
          this.$message.error('开始日期不能大于当前日期')
        } else if (this.endTimeCw > this.nowTime) {
          this.$message.error('结束日期不能大于当前日期')
        } else {
          this.monthCollectOutsideCw()
        }
      },
      // 物业月度实收报表统计
      monthCollectOutsideWy() {
        let loading = this.$loading()
        this.$get(
          `/feeActualReceipt?gardenId=${this.gardenId}&startTs=${this.startTimeWy}&endTs=${this.endTimeWy}&feeTypeCd=888800010001`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.errCode == 0) {
                this.monthCollectOutsideDataWy = res.list
                let x = res.list.map(item => (
                  item.time
                ))
                let y = res.list.map(item => (
                  item.amount
                ))
                this.getLoadEchartsWy(x, y)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取月度工单统计图表
      getLoadEchartsWy(x, y) {
        console.log(x)
        var noData = y.every(item => item <= 0)
        if (noData) {
          var dom = document.getElementById('echart1')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart1 = this.$echarts.init(
            document.getElementById('echart1')
          )
          var option1 = {
            autoHeight: true,
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              top: '0',
              right: '40',
              padding: [0, 0, 10, 0]
            },
            grid: {
              top: '15%',
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: x,
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 14
                }
              }
            },
            yAxis: [{
              minInterval: 1,
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                },
                formatter: '{value}'
              }
            }],
            series: [{
              name: '实收金额（元）',
              type: 'bar',
              barMaxWidth: 50,
              label: {
                normal: {
                  formatter: function (params) {
                    if (params.value > 0) {
                      return params.value
                    } else {
                      return ''
                    }
                  },
                }
              },
              itemStyle: {
                normal: {
                  label: {
                    show: document.body.offsetWidth > 1600, // 开启显示
                    position: 'top', // 在上方显示
                    textStyle: { // 数值样式
                      color: '#5470c6',
                      fontSize: 16
                    }
                  },
                  color: {
                    type: 'linear',
                    colorStops: [{
                        offset: 0,
                        color: '#748ede',
                      },
                      {
                        offset: 1,
                        color: '#5470c6',
                      }
                    ]
                  },
                  barBorderRadius: [8, 8, 0, 0]
                }
              },
              data: y,
            }]
          }
          myChart1.setOption(option1)
        }
      },
      // 物业月度实收报表统计
      monthCollectOutsideCw() {
        this.startTimeCw = this.startTimeCw == null ? '' : this.startTimeCw
        this.endTimeCw = this.endTimeCw == null ? '' : this.endTimeCw
        let loading = this.$loading()
        this.$get(
          `/feeActualReceipt?gardenId=${this.gardenId}&startTs=${this.startTimeCw}&endTs=${this.endTimeCw}&feeTypeCd=888800010009`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.monthCollectOutsideDataCw = res.list
              let x = res.list.map(item => (
                item.time
              ))
              let y = res.list.map(item => (
                item.amount
              ))
              this.getLoadEchartsCw(x, y)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取月度工单统计图表
      getLoadEchartsCw(x, y) {
        var noData = y.every(item => item <= 0)
        if (noData) {
          var dom = document.getElementById('echart2')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart2 = this.$echarts.init(
            document.getElementById('echart2')
          )
          var option2 = {
            autoHeight: true,
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              top: '0',
              right: '40',
              padding: [0, 0, 10, 0]
            },
            grid: {
              top: '15%',
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: x,
              axisLabel: {
                textStyle: {
                  color: '#55CCB9',
                  fontSize: 14
                }
              }
            },
            yAxis: [{
              minInterval: 1,
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#55CCB9',
                  fontSize: 16
                },
                formatter: '{value}'
              }
            }],
            series: [{
              name: '实收金额（元）',
              type: 'bar',
              barMaxWidth: 50,
              label: {
                normal: {
                  formatter: function (params) {
                    if (params.value > 0) {
                      return params.value
                    } else {
                      return ''
                    }
                  },
                }
              },
              itemStyle: {
                normal: {
                  label: {
                    show: document.body.offsetWidth > 1600, // 开启显示
                    position: 'top', // 在上方显示
                    textStyle: { // 数值样式
                      color: '#55CCB9',
                      fontSize: 16
                    }
                  },
                  color: {
                    type: 'linear',
                    colorStops: [{
                        offset: 0,
                        color: '#55CCB9',
                      },
                      {
                        offset: 1,
                        color: '#00CCA3',
                      }
                    ]
                  },
                  barBorderRadius: [8, 8, 0, 0]
                }
              },
              data: y,
            }]
          }
          myChart2.setOption(option2)
        }
      },
    }
  }
</script>

<style lang='scss'>
  .monthCollectOutside {
    min-width: 1000px;
    display: flex;
    flex-direction: column;
    height: 80vh;
    overflow: auto;

    .monthCollectOutside_card {
      margin-bottom: 20px;
      flex: 1;
    }

    .box {
      display: flex;
    }

    .cardTitle {
      font-size: 24px;
      padding-left: 10px;
    }

    .c-5470c6 {
      color: #5470c6;
    }

    .c-55ccb9 {
      color: #55ccb9;
    }

    .flexForm {
      flex: 1;
      text-align: right;
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .container {
      margin-top: 20px;
    }

    #echart1,
    #echart2 {
      width: 100%;
      height: 29vh;
    }
  }
</style>